import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ModalWindow, UIText1 } from '@cian/ui-kit';

import { StatusList as StatusListComponent } from '../../../../components/Status';
import {
  selectCurrentStatus,
  selectStatusList,
  selectStatusModalOpen,
  selectStatusLoad,
} from '../../../../selectors/status';
import { trackNewStatusClick } from '../../utils/tracking';
import { setMyHomeStatus, toggleStatusModal, updateStatus } from '../../../../actions/status';
import { EStatusLoad } from '../../../../types/redux/status';
import { Loader } from '../../../../components/Loader';
import {
  ECode,
  IMyHomeStatusInfoSchema,
} from '../../../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';
import { TThunkDispatch } from '../../../../types/redux';
import { mapECodeToEStatus } from '../../../../utils/mapECodeToEStatus';

export const StatusList: React.FC = () => {
  const [collapsed, setCollapsed] = React.useState(true);
  const dispatch = useDispatch<TThunkDispatch>();
  const isOpen = useSelector(selectStatusModalOpen);
  const currentStatus = useSelector(selectCurrentStatus);
  const statusList = useSelector(selectStatusList);
  const statusLoad = useSelector(selectStatusLoad);

  const onCollapseHandler = React.useCallback(() => {
    setCollapsed(false);
  }, []);

  const onCloseHandler = React.useCallback(() => {
    dispatch(toggleStatusModal(false));
    setCollapsed(true);
  }, [dispatch]);

  const onSetNewStatus = React.useCallback(
    async (status: IMyHomeStatusInfoSchema) => {
      trackNewStatusClick(status.code);
      dispatch(setMyHomeStatus(status));
      dispatch(toggleStatusModal(false));
      setCollapsed(true);
      await dispatch(updateStatus(mapECodeToEStatus[status.code as keyof typeof mapECodeToEStatus]));
    },
    [dispatch],
  );

  return (
    <ModalWindow
      open={isOpen}
      onClose={onCloseHandler}
      width={498}
      title="Статус объекта"
      content={
        statusLoad === EStatusLoad.loading ? (
          <Loader />
        ) : statusLoad === EStatusLoad.failed || !currentStatus ? (
          <UIText1>Что-то пошло не так, пожалуйста попробуйте позже</UIText1>
        ) : (
          <StatusListComponent
            collapsed={collapsed}
            setCollapsed={onCollapseHandler}
            currentStatus={currentStatus}
            onSetNewStatus={onSetNewStatus}
            statusList={
              currentStatus.code !== ECode.NotSelected
                ? ([statusList.find(s => s.code === currentStatus.code)].concat(
                    statusList.filter(s => s.code !== currentStatus.code),
                  ) as IMyHomeStatusInfoSchema[])
                : statusList
            }
          />
        )
      }
    />
  );
};

StatusList.displayName = 'StatusList';
